import { viewPeriod } from '../../services/viewPeriod';
import { State } from '../../types/reducer/State';

export function resetViewPeriod(state: State): State {
  const defaultViewPeriod = viewPeriod.getDefault();
  viewPeriod.set(defaultViewPeriod);
  return { ...state, viewPeriod: defaultViewPeriod };
}
